/** P339 -- Day-1 data baseline hook. */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { DataBaseline } from "shared/api/types";

export const dataBaselineKeys = {
  read: ["readiness", "data-baseline"] as const,
};

export function useDataBaseline(): UseQueryResult<DataBaseline, ApiError> {
  return useQuery({
    queryKey: dataBaselineKeys.read,
    queryFn: () => api.get<DataBaseline>("/v1/readiness/data-baseline"),
  });
}
